import "./NoJobSelectedComponent.scss";
import {ImageConfig} from "../../constants";

const NoJobSelectedComponent=()=>{
    return (
        <div className="no-job-details-wrapper">
            <div className="empty-state-content">
                <div className="icon-container">
                    <ImageConfig.DesktopIcon/>
                </div>
                <h3 className="empty-state-title">No Job Selected</h3>
                <p className="empty-state-description">
                    Select a job from the list to view details.
                </p>
                <div className="empty-state-hint">
                    <span className="hint-icon">💡</span>
                    <span>Click on any job listing to get started</span>
                </div>
            </div>
        </div>
    )
}

export default NoJobSelectedComponent